import React, { useEffect, useState } from 'react';
import {
    useSelector,
} from 'react-redux';
import { isEmpty } from 'underscore';
import moment from 'moment';

import {
    Table,
    notification,
    Empty,
    Spin,
    Tooltip,
    Form,
    Checkbox,
} from 'antd';

// import SearchForm from './SearchForm';

import './scores.scss';
import { InfoOutlined } from '../icons';

let count = 0;

const ScoresBlock = () => {
    const isFetching = useSelector((state) => state.patient.isFetching);
    const temporaryPassword = useSelector((state) => state.patient.temporaryPassword);

    const [isTraining, setIsTraining] = useState(true);
    const [isAssessment, setIsAssessment] = useState(true);

    const singlePatient = useSelector((state) => state.patient.singlePatient);
    // Using sessions data (maintains backward compatibility through API)
    const sessions = singlePatient?.assessmentRecords?.sort((a, b) => moment(b?.completed_timestamp) - moment(a?.completed_timestamp))?.slice(0, 30)?.filter((val) => {
        const sessionType = val?.type;
        if (!isTraining && sessionType === 2) {
            return false;
        }
        if (!isAssessment && sessionType === 1) {
            return false;
        }
        return true;
    }).map((val) => {
        const session = val;
        const completedTimestamp = moment(val?.completed_timestamp)?.format('YYYY-MM-DD');
        const sessionMeta = singlePatient?.assessmentMeta[completedTimestamp];
        const metaScore = (sessionMeta?.find(meta => meta.date === session?.completed_timestamp))?.score;

        // Ensure score is always a valid number, fallback to 0 if undefined/null/NaN
        session.score = (metaScore !== undefined && metaScore !== null && !Number.isNaN(metaScore)) ? metaScore : 0;

        return session;
    });

    useEffect(() => {
        count = 0;
    }, []);

    useEffect(() => {
        if (temporaryPassword && count > 0) {
            notification.success({
                message: `Password creation successful - the patients new password is "${temporaryPassword}"`,
            });
        }
        count += 1;
    }, [temporaryPassword]);

    const getSessionTypeText = (sessionType) => {
        switch (sessionType) {
        case 1:
            return 'Assessment';
        case 2:
            return 'Training';
        default:
            return 'N/a';
        }
    };

    const renderTooltip = () => (
        <Tooltip title="The Score metric is the highest score achieved by the patient on the date recorded." color="#3F8CC8">
            <div className="info-button"><InfoOutlined /></div>
        </Tooltip>
    );

    const columns = [
        {
            title: 'Session Type',
            dataIndex: 'type',
            render: (_, record) => (
                <span className="signal-wrapper">
                    {getSessionTypeText(record.type)}
                </span>
            ),
        },
        {
            title: 'Level',
            dataIndex: 'level',
        },
        {
            title: <div className="tooltip-wrapper">Score {renderTooltip()}</div>,
            dataIndex: 'score',
            render: (_, record) => {
                const { score } = record;
                if (score === undefined || score === null || Number.isNaN(score)) {
                    return 'N/A';
                }
                return `${Math.round(score)}%`;
            },
        },
        {
            title: 'Date',
            dataIndex: '',
            render: (_, record) => {
                const timestamp = record?.completed_timestamp;
                if (!timestamp) {
                    return <span className="signal-wrapper">N/A</span>;
                }

                const date = moment(timestamp);
                if (!date.isValid()) {
                    return <span className="signal-wrapper">Invalid Date</span>;
                }

                return (
                    <span className="signal-wrapper">
                        {date.format('D/M/YYYY')}
                    </span>
                );
            },
        },
    ];

    return (
        <Spin tip="Loading" size="small" spinning={isFetching}>
            <div className="score-block-wrapper">
                <div className="search-block">
                    <div className="form-content">
                        <Form
                            className="scores-form"
                            onFinish={() => console.log('on finish')}
                            onFinishFailed={() => console.log('on finish failed')}
                            layout="vertical">

                            <p>Select which session type(s) you want to view:</p>
                            <Checkbox
                                checked={isTraining}
                                onChange={(e) => setIsTraining(e.target.checked)}>
                                Training
                            </Checkbox>
                            <Checkbox
                                checked={isAssessment}
                                onChange={(e) => setIsAssessment(e.target.checked)}>
                                Assessment
                            </Checkbox>
                        </Form>
                    </div>
                </div>
                <div className="content-block stripped-table">
                    {isEmpty(sessions)
                        ? <Empty description="No Results Found" />
                        : (
                            <Table
                                rowKey="id"
                                loading={isFetching}
                                columns={columns}
                                pagination={false}
                                dataSource={sessions}
                                onChange={(something) => console.log('on change', something)} />
                        )}
                </div>
            </div>
        </Spin>
    );
};

export default ScoresBlock;

ScoresBlock.propTypes = {};
